export const REFRESH_PROJECT_MOODBOARD =
  'app/javascript/design/constants/REFRESH_PROJECT_MOODBOARD';
export const UPDATE_PROJECT_MOODBOARD = 'app/javascript/design/constants/UPDATE_PROJECT_MOODBOARD';



// WEBPACK FOOTER //
// ./app/javascript/design/constants/moodboard.js